import store from "@/store";
import { setUser } from "@sentry/vue";

export const userSentryInstall = () => {
  setUser(store.getters["auth/profile"]);
};
